import { Col, Form, Input, InputNumber, Radio, Row, Button, Space, message } from 'antd';
import React, { useEffect, useState } from 'react'
import { SketchPicker } from 'react-color';
import ValidatorHelper from '../helpers/ValidatorHelper';
import { usePersistedStore } from '../../store/persisted-store';

const BusinessStyles = (props) => {
    const { styleTabCols, styleTabLayout, Styles, setStyles, ColorPickerStatus, setColorPickerStatus, tabId, popover, cover, layout } = props;
    const { postBusinessStyles, business, getBusinesses } = usePersistedStore();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const currentBusiness = business.businesses?.byToken;
    const sourceBuiness = business.currentBusiness

    useEffect(() => {
        setStyles({
            ...Styles,
            isDarkMode: !!Styles?.isDarkMode,
        })
    }, [])

    const onSubmitStyles = async () => {
        try {
            if (!Styles || !Styles.primaryColor || !Styles.secondaryColor) {
                message.error({
                    content: 'رنگ اصلی و دوم را انتخاب کنید',
                    style: {
                        marginTop: '20vh',
                    }
                });
                return;
            }

            setLoading(true);
            await postBusinessStyles({
                styles: {
                    isDarkMode: Styles.isDarkMode || false,
                    primaryColor: Styles.primaryColor,
                    secondaryColor: Styles.secondaryColor,
                    bulletsBackgroundColor: Styles.bulletsBackgroundColor,
                    bulletsSvgColor: Styles.bulletsSvgColor,
                    cardsRadius: Styles.cardsRadius,
                    buttonsInputsRadius: Styles.buttonsInputsRadius,
                    backgroundColor: Styles.backgroundColor,
                    headerTextColor: Styles.headerTextColor,
                    bulletsTitleColor: Styles.bulletsTitleColor,
                    footerTextColor: Styles.footerTextColor,
                    headerBackgroundColor: Styles.headerBackgroundColor,
                    footerBackgroundColor: Styles.footerBackgroundColor
                }
            },
                currentBusiness.token,
                sourceBuiness.token
            );
            setTimeout(() => {
                getBusinesses()
            }, 500)
        } catch (error) {
            // test intended do not overact on it
            console.error('Error submitting styles:', error);
            message.error('خطا در بروزرسانی استایل‌ها');
        } finally {
            setLoading(false);
        }
    };
    return (
        <Form
            form={form}
            {...layout}
            layout="horizontal"
            name="add_company"
            className='business-form position-relative'
            style={{ paddingBottom: 68 }}

        >
            <div
                className={`tabViewPort ${(tabId === "3") ? 'visibleTab' : null}`}>
                <Row>
                    <Col {...styleTabCols} style={{ marginRight: 0 }}>
                        <Form.Item
                            className="formItem"
                            label="قالب"
                        >
                            <Radio.Group
                                value={Styles?.isDarkMode}
                                onChange={e => setStyles({ ...Styles, isDarkMode: e.target.value })}
                            >
                                <Radio value={false}>روشن</Radio>
                                <Radio value={true}>تیره</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            {...styleTabLayout} className="formItem" name="primaryColor" label="رنگ اصلی">
                            <div className='color-box' style={{ backgroundColor: Styles && Styles.primaryColor }}></div>
                            <Input value={Styles?.primaryColor} onFocus={() => { setColorPickerStatus("primaryColor"); }} />
                        </Form.Item>
                        {ColorPickerStatus === "primaryColor" ?
                            <div style={popover}>
                                <div style={cover} onClick={() => setColorPickerStatus("")} />
                                <SketchPicker
                                    color={Styles?.primaryColor}
                                    onChangeComplete={(color) => setStyles({
                                        ...Styles,
                                        primaryColor: color?.hex,
                                    })} />
                            </div> : null}
                        <Form.Item {...styleTabLayout} className="formItem" name="secondaryColor" label="رنگ دوم">
                            <div className='color-box' style={{ backgroundColor: Styles && Styles.secondaryColor }}></div>
                            <Input value={Styles?.secondaryColor} onFocus={() => setColorPickerStatus("secondaryColor")} />
                        </Form.Item>
                        {ColorPickerStatus === "secondaryColor" ?
                            <div style={popover}>
                                <div style={cover} onClick={() => setColorPickerStatus("")} />
                                <SketchPicker
                                    color={Styles?.secondaryColor}
                                    onChangeComplete={(color) => setStyles({
                                        ...Styles,
                                        secondaryColor: color?.hex,
                                    })} />
                            </div> : null}
                        <Form.Item {...styleTabLayout} className="formItem" name="backgroundColor" label="رنگ پس‌زمینه">
                            <div className='color-box' style={{ backgroundColor: Styles && Styles.backgroundColor }}></div>
                            <Input value={Styles?.backgroundColor} onFocus={() => { setColorPickerStatus("backgroundColor"); }} />
                        </Form.Item>
                        {ColorPickerStatus === "backgroundColor" ?
                            <div style={popover}>
                                <div style={cover} onClick={() => setColorPickerStatus("")} />
                                <SketchPicker
                                    color={Styles?.backgroundColor}
                                    onChangeComplete={(color) => setStyles({
                                        ...Styles,
                                        backgroundColor: color?.hex,
                                    })} />
                            </div> : null}

                        <Form.Item {...styleTabLayout} name="bulletsBackgroundColor" label="رنگ پس زمینه آیکون رشته ها">
                            <div className='color-box' style={{ backgroundColor: Styles && Styles?.bulletsBackgroundColor }}></div>
                            <Input value={Styles?.bulletsBackgroundColor} onFocus={() => { setColorPickerStatus("bulletsBackgroundColor") }} />
                        </Form.Item>
                        {ColorPickerStatus === "bulletsBackgroundColor" ?
                            <div style={popover}>
                                <div style={cover} onClick={() => setColorPickerStatus("")} />
                                <SketchPicker
                                    color={Styles?.bulletsBackgroundColor}
                                    onChangeComplete={(color) => setStyles({
                                        ...Styles,
                                        bulletsBackgroundColor: color?.hex,
                                    })} />
                            </div> : null}
                        <Form.Item {...styleTabLayout} name="bulletsSvgColor" label="رنگ آیکون رشته ها">
                            <div className='color-box' style={{ backgroundColor: Styles && Styles?.bulletsSvgColor }}></div>
                            <Input value={Styles?.bulletsSvgColor} onFocus={() => { setColorPickerStatus("bulletsSvgColor") }} />
                        </Form.Item>
                        {ColorPickerStatus === "bulletsSvgColor" ?
                            <div style={popover}>
                                <div style={cover} onClick={() => setColorPickerStatus("")} />
                                <SketchPicker color={Styles?.bulletsSvgColor}
                                    onChangeComplete={(color) => setStyles({
                                        ...Styles,
                                        bulletsSvgColor: color?.hex,
                                    })} />
                            </div> : null}
                        <Form.Item {...styleTabLayout} className="formItem" name="buttonsInputsRadius" label="انحنای بوردر دکمه ها و اینپوت ها"
                            rules={ValidatorHelper.borderRadius('انحنا بوردر', 30)}
                            extra='حداکثر مجاز، 30 پیکسل'>
                            <InputNumber
                                onChange={(e) => {
                                    setStyles({
                                        ...Styles,
                                        buttonsInputsRadius: e + 'px'
                                    })
                                }}
                                min={0}
                                max={30}
                                style={{ buttonsInputsRadius: Styles && Styles?.buttonsInputsRadius }}
                            />
                        </Form.Item>

                    </Col>
                    <Col {...styleTabCols}>

                        <Form.Item {...styleTabLayout} className="formItem" name="headerTextColor" label="رنگ متن آیتم های هدر">
                            <div className='color-box' style={{ backgroundColor: Styles && Styles.headerTextColor }}></div>
                            <Input value={Styles?.headerTextColor} onFocus={() => { setColorPickerStatus("headerTextColor") }} />
                        </Form.Item>
                        {ColorPickerStatus === "headerTextColor" ?
                            <div style={popover}>
                                <div style={cover} onClick={() => setColorPickerStatus("")} />
                                <SketchPicker
                                    color={Styles?.headerTextColor}
                                    onChangeComplete={(color) => setStyles({
                                        ...Styles,
                                        headerTextColor: color?.hex,
                                    })} />
                            </div> : null}
                        <Form.Item {...styleTabLayout} className="formItem" name="footerTextColor" label="رنگ متن آیتم های فوتر">
                            <div className='color-box' style={{ backgroundColor: Styles && Styles.footerTextColor }}></div>
                            <Input value={Styles?.footerTextColor} onFocus={() => { setColorPickerStatus("footerTextColor") }} />
                        </Form.Item>
                        {ColorPickerStatus === "footerTextColor" ?
                            <div style={popover}>
                                <div style={cover} onClick={() => setColorPickerStatus("")} />
                                <SketchPicker
                                    color={Styles?.footerTextColor}
                                    onChangeComplete={(color) => setStyles({
                                        ...Styles,
                                        footerTextColor: color?.hex,
                                    })} />
                            </div> : null}
                        <Form.Item {...styleTabLayout} className="formItem" name="headerBackgroundColor" label="رنگ پس‌زمینه هدر و تولبار در سایز موبایل">
                            <div className='color-box' style={{ backgroundColor: Styles && Styles.headerBackgroundColor }}></div>
                            <Input value={Styles?.headerBackgroundColor} onFocus={() => { setColorPickerStatus("headerBackgroundColor") }} />
                        </Form.Item>
                        {ColorPickerStatus === "headerBackgroundColor" ?
                            <div style={popover}>
                                <div style={cover} onClick={() => setColorPickerStatus("")} />
                                <SketchPicker
                                    color={Styles?.headerBackgroundColor}
                                    onChangeComplete={(color) => setStyles({
                                        ...Styles,
                                        headerBackgroundColor: color?.hex,
                                    })} />
                            </div> : null}
                        <Form.Item {...styleTabLayout} className="formItem" name="footerBackgroundColor" label="رنگ پس زمینه فوتر">
                            <div className='color-box' style={{ backgroundColor: Styles && Styles.footerBackgroundColor }}></div>
                            <Input value={Styles?.footerBackgroundColor} onFocus={() => { setColorPickerStatus("footerBackgroundColor") }} />
                        </Form.Item>
                        {ColorPickerStatus === "footerBackgroundColor" ?
                            <div style={popover}>
                                <div style={cover} onClick={() => setColorPickerStatus("")} />
                                <SketchPicker
                                    color={Styles?.footerBackgroundColor}
                                    onChangeComplete={(color) => setStyles({
                                        ...Styles,
                                        footerBackgroundColor: color?.hex,
                                    })} />
                            </div> : null}
                        <Form.Item {...styleTabLayout} className="formItem" name="cardsRadius" label="انحنای بوردر باکس ها"
                            rules={ValidatorHelper.borderRadius('انحنا بوردر', 30)}
                            extra='حداکثر مجاز، 30 پیکسل'>
                            <InputNumber
                                onChange={(e) => {
                                    setStyles({
                                        ...Styles,
                                        cardsRadius: e + 'px'
                                    })
                                }}
                                min={0}
                                max={30}
                                style={{ cardsRadius: Styles && Styles.cardsRadius }}
                            />
                        </Form.Item>

                        <Form.Item
                            {...styleTabLayout}
                            className="formItem"
                            name="bulletsTitleColor"
                            label="رنگ عنوان رشته ها"
                        // rules={[{ required: true, message: 'لطفا رنگ عنوان رشته ها  را  وارد کنید.' }]}
                        >
                            <div
                                className='color-box'
                                style={{ backgroundColor: Styles && Styles.bulletsTitleColor }}
                            ></div>
                            <Input
                                value={Styles && Styles.bulletsTitleColor}
                                onFocus={() => setColorPickerStatus("bulletsTitleColor")}
                            />
                        </Form.Item>
                        {ColorPickerStatus === "bulletsTitleColor" ?
                            <div style={popover}>
                                <div style={cover} onClick={() => setColorPickerStatus("")} />
                                <SketchPicker
                                    color={Styles?.bulletsTitleColor}
                                    onChangeComplete={(color) => setStyles({
                                        ...Styles,
                                        bulletsTitleColor: color?.hex,
                                    })} />
                            </div> : null}
                    </Col>
                </Row>
                <div style={{
                    background: 'var(--glass-raised)',
                    backdropFilter: 'var(--blur-md)',
                    WebkitBackdropFilter: 'var(--blur-md)',
                    borderTop: 'var(--glass-border)',
                    boxShadow: 'var(--shadow-md)',
                    padding: '10px 0',
                    position: 'absolute',
                    display: 'flex',
                    marginTop: '30px',
                    justifyContent: 'end',
                    marginLeft: '0px',
                    bottom: '0px',
                    left: '62px',
                    width: '100%'
                }}>

                    <Row>
                        <Col>
                            <Space>
                                <Button
                                    className="primary-button"
                                    onClick={onSubmitStyles}
                                    loading={loading}
                                >
                                    ذخیره استایل‌ها
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                </div>
            </div>
        </Form>
    )
}

export default BusinessStyles